import React from 'react';
import ChapterBasicInfoComponent from './chapter-basic-info.component';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';

export const ChapterComponent = ({
    selectLMSChapters, handleInnerFormChange, back, handleFormSubmit
}: any) => {
    const tabItems = [
        {
            id: 1,
            title: 'Chapter Basic Information',
            component: <ChapterBasicInfoComponent
                handleInnerFormChange={handleInnerFormChange}
                selectLMSChapters={selectLMSChapters}
            />,
            isVisible: true,
        },
    ]

    return (
        <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">
            <TabContainer tabItems={tabItems} />

            <div className='flex w-full justify-end items-end'>
                <button
                    onClick={back}
                    type='button'
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                >
                    Back
                </button>
                <button
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                    onClick={handleFormSubmit}
                    type="submit"
                >
                    Save
                </button>
            </div>
        </div>
    )
}

export default ChapterComponent;
